import { Box, Stack, Typography } from '@mui/material'
import { ProjectType } from 'api'
import { SettingsItem } from 'components/global'
import { Dialog } from 'elements/feedback'
import { useBoolean } from 'lib/hooks'
import { useTranslation } from 'react-i18next'

import { EditProjectInfoForm } from './edit-project-info-form'
import { ProjectAvatarBlock } from './project-avatar-block'

type ProjectInfoBlockProps = {
  projectId: string
  name: string
  description: string
  type: ProjectType
  avatarSrc?: string
}

export const ProjectInfoBlock = ({
  projectId,
  name,
  description,
  type,
  avatarSrc,
}: ProjectInfoBlockProps) => {
  const { t } = useTranslation()

  const isOpen = useBoolean()

  return (
    <>
      <SettingsItem
        title={t('projects.settings.project_information')}
        onClick={isOpen.setTrue}
      >
        <Stack spacing={2.5}>
          <Box display="flex" alignItems="center">
            <ProjectAvatarBlock
              projectId={projectId}
              projectName={name}
              avatarSrc={avatarSrc}
            />

            <Typography variant="caption1" ml={2.5}>
              {name}
            </Typography>
          </Box>

          <Box>
            <Typography
              variant="caption2"
              mb={1}
              display="block"
              color="text.secondary"
            >
              {t('projects.settings.project_description')}
            </Typography>

            <Typography variant="caption2" display="block">
              {description}
            </Typography>
          </Box>

          <Box>
            <Typography
              variant="caption2"
              mb={1}
              display="block"
              color="text.secondary"
            >
              {t('projects.settings.project_type')}
            </Typography>

            <Typography variant="caption2" display="block">
              {t(`projects.project_types.${type}`)}
            </Typography>
          </Box>
        </Stack>
      </SettingsItem>

      <Dialog open={isOpen.isTrue} onClose={isOpen.setFalse}>
        <EditProjectInfoForm
          projectId={projectId}
          name={name}
          description={description}
          onClose={isOpen.setFalse}
        />
      </Dialog>
    </>
  )
}
